import { Flex } from 'front-commons/ds';
import styled from 'styled-components';
import { ContainerBoniProps } from './interfaces';
export const ContainerBoni = styled(Flex)<ContainerBoniProps>`
	position: relative;
	background: #f6f0fe;
	border-radius: 8px;
	overflow: hidden;
	&::before {
		content: '';
		position: absolute;
		width: 125px;
		height: 125px;
		border-radius: 50%;
		background: var(--boni-purple);

		${({ variant }) => (variant === 'revision' ? 'left: -50px' : 'left: -48px')};
		${({ variant }) => (variant === 'revision' ? 'top: -15px' : 'top: 12%')};

		@media (max-width: 768px) {
			${({ variant }) => (variant === 'revision' ? 'left: -50px' : 'left: -50px')};
			${({ variant }) => (variant === 'revision' ? 'top: -15px' : 'top: -15px')};
		}
	}
	&::after {
		content: '';
		position: absolute;
		width: 140px;
		height: 140px;
		border-radius: 50%;
		background: var(--boni-purple);

		${({ variant }) => (variant === 'revision' ? 'top: 75px' : 'top: -70px')};
		${({ variant }) => (variant === 'revision' ? 'right: -50px' : 'right: -50px')};

		@media (max-width: 768px) {
			${({ variant }) => (variant === 'revision' ? 'top: 60px' : 'top: 60px')};
			${({ variant }) => (variant === 'revision' ? 'right: -60px' : 'right: -60px')};
		}
	}

	& * {
		cursor: pointer;
	}
`;
